import TooltipWrapper, { TRIGGER_OPTIONS } from './TooltipWrapper';

export default TooltipWrapper;
export { TRIGGER_OPTIONS };
